import {
  defaultPreparationProfile,
  PreOrderPeriodUnit,
  preparationPreOrderPeriodUnitOptions,
  PreparationTimeUnit,
} from '../constants/preparationProfiles';
import preparationProfilesStore from '../store/preparationProfilesStore';
import { IPreparationProfile, IResponsePreparationProfile, TPreparationProfileBranch } from '../types/preparationProfiles';
import { localeStore } from '~/mobx/localesStore';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import { IBranchesModalItem } from '~/view/containers/Modals/BranchesModal/BranchesModal';

export const preparationProfileBranchCast = (data: IBranchesModalItem): TPreparationProfileBranch => {
  return {
    id: data.id,
    name: data.name,
    status: data.status || 1,
    is_delete: data.is_delete || 0,
  };
};

export const preparationProfileCast = (data: IResponsePreparationProfile): IPreparationProfile => {
  return {
    id: data.id,
    externalId: data.external_id || defaultPreparationProfile.externalId,
    name: data.name,
    deliveryUnit: data.delivery_unit || defaultPreparationProfile.deliveryUnit,
    deliveryTime: String(data.delivery_time) || defaultPreparationProfile.deliveryTime,
    deliveryPreparationTime: String(data.delivery_preparation_time) || defaultPreparationProfile.deliveryPreparationTime,
    pickupUnit: data.pickup_unit || defaultPreparationProfile.pickupUnit,
    pickupTime: String(data.pickup_time) || defaultPreparationProfile.pickupTime,
    pickupPreparationTime: String(data.pickup_preparation_time) || defaultPreparationProfile.pickupPreparationTime,
    preOrderPeriod: String(data.preorder_days) || defaultPreparationProfile.preOrderPeriod,
    preOrderPeriodUnit: data.preorder_period || defaultPreparationProfile.preOrderPeriodUnit,
    preOrderInterval: data.preorder_interval || defaultPreparationProfile.preOrderInterval,
    branches: data.branches || defaultPreparationProfile.branches,
    is_default: data.is_default ?? defaultPreparationProfile.is_default,
  };
};

export const getPreparationProfileParams = (data: IPreparationProfile) => {
  return {
    id: data.id,
    external_id: data.externalId,
    name: data.name,
    delivery_unit: data.deliveryUnit,
    delivery_time: Number(data.deliveryTime) || 0,
    delivery_preparation_time: Number(data.deliveryPreparationTime) | 0,
    pickup_unit: data.pickupUnit,
    pickup_time: Number(data.pickupTime) || 0,
    pickup_preparation_time: Number(data.pickupPreparationTime) || 0,
    preorder_days: data.preOrderPeriodUnit === PreOrderPeriodUnit.ONLY_TODAY ? 0 : Number(data.preOrderPeriod) || 0,
    preorder_period: data.preOrderPeriodUnit,
    preorder_interval: data.preOrderInterval,
    branches: data.branches.map((branch) => branch.id),
  };
};

export const getPreparationTimeUnitOption = (key: PreparationTimeUnit): IPickerOption[] | undefined => {
  if (!key) return undefined;
  return [{ label: localeStore.t(key), value: key }];
};

export const getPreparationPreOrderPeriodOption = (key: PreOrderPeriodUnit): IPickerOption => {
  const options: IPickerOption[] = preparationPreOrderPeriodUnitOptions();
  return options.find((option) => option.value === key) || options[0];
};

export const preparationPreOrderPeriodMessage = (): string | null => {
  const { preOrderPeriodUnit } = preparationProfilesStore.selectedProfile;

  switch (true) {
    case preOrderPeriodUnit === PreOrderPeriodUnit.DAYS:
      return 'please_enter_number_of_days_from_year';
    case preOrderPeriodUnit === PreOrderPeriodUnit.WEEKS:
      return 'please_enter_number_of_weeks_from_year';
    case preOrderPeriodUnit === PreOrderPeriodUnit.MONTHS:
      return 'please_enter_number_of_months_from_year';
    case preOrderPeriodUnit === PreOrderPeriodUnit.ONLY_TODAY:
    default:
      return null;
  }
};
